var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.161 7.326l-.65 4.228a2 2 0 01-1.977 1.696H3.466a2 2 0 01-1.977-1.696L.84 7.326a.5.5 0 01.494-.576h13.334a.5.5 0 01.494.576z",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.882 2c.612 0 1.175.32 1.491.835l.074.132.099.198a.607.607 0 00.445.327l.098.008h5.161a1.75 1.75 0 011.744 1.606L15 5.25v.795a1.25 1.25 0 01.903 1.395l-.65 4.228A2.75 2.75 0 0112.533 14H3.466a2.75 2.75 0 01-2.718-2.332L.098 7.44A1.25 1.25 0 011 6.045V3.75a1.75 1.75 0 011.606-1.744L2.75 2h3.132zm8.494 5.5H1.623l.607 3.94c.088.57.55 1 1.114 1.054l.122.006h9.068a1.25 1.25 0 001.236-1.06l.606-3.94zm-8.494-4H2.75a.25.25 0 00-.243.193L2.5 3.75V6h11v-.75a.25.25 0 00-.193-.243L13.25 5H8.089a2.107 2.107 0 01-1.803-1.016l-.082-.149-.098-.197a.25.25 0 00-.168-.132L5.882 3.5z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen16);
export default __webpack_public_path__ + "static/media/folder-open-16.2ef8d9da.svg";
export { ForwardRef as ReactComponent };